import gql from 'graphql-tag';

export const getAreas = gql`
  query getAreas {
    getAreas {
      id
      name
      region {
        id
        name
      }
    }
  }
`;
